import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableNewProductImport = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableNewProductImport);
};
